import type { ShapeDividersLayersEffect } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const getMaxLayerSize = (
	layersEffects: Array<ShapeDividersLayersEffect>
): ShapeDividersLayersEffect | undefined => _.maxBy(layersEffects, (x) => x?.size || 0)
